module.exports = __webpack_public_path__ + "static/img/h5-3.246929f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/h5-3.png
// module id = uNP+
// module chunks = 1